/**
 * Replace long text with dots.
 *
 * @author Ihar Kazlouski
 * @param {string} text text.
 * @return {number} maxLength max acceptable length.
 */
var longTextReplacer = function longTextReplacer(text, maxLength) {
  if ((text === null || text === void 0 ? void 0 : text.length) > maxLength) {
    return (text === null || text === void 0 ? void 0 : text.substring(0, maxLength)) + '...';
  }

  return text;
};

export { longTextReplacer };